import { MerkurEvent } from "./MerkurEvent";
import {
    rmtCustomImpressionEvent,
    rmtCustomClickEvent,
    defaultClickEvent
} from "./config";

export class MerkurTracking extends HTMLElement {
    constructor() {
        super();
        if (!window.merkur || typeof window.merkur.trackGenericEvent !== "function") {
            return;
        }
        this.events = ["click", rmtCustomImpressionEvent];
        this.addListener();
        window.addEventListener("beforeunload", () => {
            this.removeListener();
        });
    }

    get isKategorie() {
        return this.dataset["seitentyp"] === "kategorie";
    }

    disconnectedCallback() {
        this.removeListener();
    }

    addListener() {
        for (const event of this.events) {
            window.addEventListener(event, this, { capture: true });
        }
    }

    removeListener() {
        for (const event of this.events) {
            window.removeEventListener(event, this, { capture: true });
        }
    }

    handleEvent(event) {
        const { type } = event;
        switch (type) {
            // CustomEvents
            case rmtCustomImpressionEvent:
                this.handleRmtImpression(event);
                break;
            // Default Events
            default:
                this[`handle${type}`](event);
                break;
        }
    }

    handleclick(event) {
        const { target } = event;
        if (!target) {
            return;
        }
        const dlElement = target.querySelector("dl-product") || target.querySelector("dl-promotion");
        if (!dlElement) {
            return;
        }
        const eventName = dlElement.getAttribute("merkur-event");
        if (!eventName) {
            return;
        }
        const merkurEventName = eventName.toLowerCase() === "rmt" ? rmtCustomClickEvent : defaultClickEvent;
        const trackingToken = dlElement.getAttribute("trackingtoken") || "";
        const isListingProduct = trackingToken.startsWith("coveo-mh:");
        if (merkurEventName === defaultClickEvent && this.isKategorie && !isListingProduct) {
            return;
        }
        this.sendMerkurEvent(merkurEventName, dlElement);
    }

    handleRmtImpression(event) {
        const { target } = event.detail;
        if (!target) {
            return;
        }
        this.sendMerkurEvent(rmtCustomImpressionEvent, target);
    }

    sendMerkurEvent(eventName, dlElement) {
        const data = this.getDataFromAttributes(dlElement);
        const merkurEvent = new MerkurEvent(eventName, data);
        merkurEvent.send();
    }

    getDataFromAttributes(target) {
        const data = {};
        for (const attribute of Array.from(target.attributes)) {
            data[attribute.name] = attribute.value;
        }
        return data;
    }
}

if (!customElements.get("merkur-tracking")) {
    customElements.define("merkur-tracking", MerkurTracking);
}
